import { render, staticRenderFns } from "./SearchDetail.vue?vue&type=template&id=3f485d8e&scoped=true"
import script from "./SearchDetail.vue?vue&type=script&lang=js"
export * from "./SearchDetail.vue?vue&type=script&lang=js"
import style0 from "./SearchDetail.vue?vue&type=style&index=0&id=3f485d8e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f485d8e",
  null
  
)

export default component.exports